import { Button } from 'antd';

import { notificationActions, openNotificationUrl } from '../../utils/notificationDisplay';

const NotificationActionButtons = ({ notification, navigate, onNavigate, size = 'small', className = '' }) => {
  const actions = notificationActions(notification);
  if (!actions.length) return null;

  return (
    <div className={`flex flex-wrap gap-1.5 ${className}`.trim()}>
      {actions.map((action) => (
        <Button
          key={`${action.label}:${action.url}`}
          size={size}
          type={action.external || actions.length === 1 ? 'primary' : 'default'}
          className="!h-7 !rounded-lg !text-xs"
          onClick={(event) => {
            event.preventDefault();
            event.stopPropagation();
            onNavigate?.();
            openNotificationUrl(action.url, navigate);
          }}
        >
          {action.label}
        </Button>
      ))}
    </div>
  );
};

export default NotificationActionButtons;
